import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { RequestsService } from '../services/requests.service';
import * as XLSX from 'xlsx';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-driver-partner-request',
  templateUrl: './driver-partner-request.component.html',
  styleUrls: ['./driver-partner-request.component.sass']
})
export class DriverPartnerRequestComponent implements OnInit {
  searchText:any;
  itemsPerPage = 5;
  
  page_Pending: number = 0;
  totalItems_Pending:any;
  allDriverPartner_PendingRequests:any;

  page_InProcess: number = 0;
  totalItems_InProcess:any;
  allDriverPartner_InProcessRequests:any;

  page_Completed: number = 0;
  totalItems_Completed:any;
  allDriverPartner_CompletedRequests:any;

  page_Rejected: number = 0;
  totalItems_Rejected:any;
  allDriverPartner_RejectedRequests:any;
  
  driverDocumentsData = [];

  changeStatusId:any="";
  driverId = "";
  allDriverPartnerRequestsList_forFilter:any;
  closeResult:any;
  viewAllData:any;
  status:String = "";
  
  isBannerPasted:boolean= false;
  pendingReason:String="";
  rejectReason:String="";

  constructor(private toastr:ToastrService,
              private spinner :NgxSpinnerService,
              private driverPartnerService :RequestsService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getDriverPartnerRequests_Pending();
    this.getDriverPartnerRequests_InProcess();
    this.getDriverPartnerRequests_Completed();
    this.getDriverPartnerRequests_Rejected();
    this.getVehicles()
  }


  //  Pending Requests Start
  getDriverPartnerRequests_Pending(){
    this.spinner.show();       
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    : this.page_Pending ,
      "isDeleted": 0,
      "verificationStatus" : 0,
    }
    // console.log(data)
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      console.log('1st Data In Pagination ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allDriverPartner_PendingRequests = result.data
        this.totalItems_Pending = result.totalRecords;
      }else{
        this.allDriverPartner_PendingRequests = [];
      }
    })
  }

  gty_Pending(page: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :this.page_Pending -1,
      "isDeleted": 0,
      "verificationStatus" : 0
    }
    console.log("Req Data Pending",data)
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      console.log('pagination ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allDriverPartner_PendingRequests = result.data
      }else{
        this.allDriverPartner_PendingRequests = [];
      }
    })
  }
//  Pending Requests End


//  In-Process Requests Start
  getDriverPartnerRequests_InProcess(){
    this.spinner.show();       
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    : 0,
      "isDeleted": 0,
      "verificationStatus" : 1
    }
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      // console.log('all data  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allDriverPartner_InProcessRequests = result.data
        this.totalItems_InProcess = result.totalRecords;
      }else{
        this.allDriverPartner_InProcessRequests = [];
      }
    })
  }

  gty_InProcess(page_Completed: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :page_Completed-1,
      "isDeleted": 0,
      "verificationStatus" : 1
    }
    console.log("In-process_GTY_REQ", data)
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      console.log('In-process_GTY_RES  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allDriverPartner_InProcessRequests = result.data
      }else{
        this.allDriverPartner_InProcessRequests = [];
      }
    })
  }
//  In-Process Requests End

//  Completed Requests Start
getDriverPartnerRequests_Completed(){
  this.spinner.show();       
  let data = { 
    "perPage" : this.itemsPerPage,
    "page"    : 0,
    "isDeleted": 0,
    "verificationStatus" : 2
  }
  this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
    // console.log('all data  ',result);
    this.spinner.hide()
    if(result.statusCode == 200){
      this.allDriverPartner_CompletedRequests = result.data
      this.totalItems_Completed = result.totalRecords;
    }else{
      this.allDriverPartner_CompletedRequests = [];
    }
  })
}

gty_Completed(page: any){
  this.spinner.show();
  let data = { 
    "perPage" : this.itemsPerPage,
    "page"    :page-1,
    "isDeleted": 0,
    "verificationStatus" : 2
  }
  this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
    // console.log('all data  ',result);
    this.spinner.hide()
    if(result.statusCode == 200){
      this.allDriverPartner_CompletedRequests = result.data
    }else{
      this.allDriverPartner_CompletedRequests = [];
    }
  })
}
//  Completed Requests End

//  Rejected Requests Start
getDriverPartnerRequests_Rejected(){
  this.spinner.show();       
  let data = { 
    "perPage" : this.itemsPerPage,
    "page"    : 0,
    "isDeleted": 0,
    "verificationStatus" : 3
  }
  this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
    // console.log('all data  ',result);
    this.spinner.hide()
    if(result.statusCode == 200){
      this.allDriverPartner_RejectedRequests = result.data
      this.totalItems_Rejected = result.totalRecords;
    }else{
      this.allDriverPartner_RejectedRequests = [];
    }
  })
}

gty_Rejected(page: any){
  this.spinner.show();
  let data = { 
    "perPage" : this.itemsPerPage,
    "page"    :page-1,
    "isDeleted": 0,
    "verificationStatus" : 3
  }
  this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
    // console.log('all data  ',result);
    this.spinner.hide()
    if(result.statusCode == 200){
      this.allDriverPartner_RejectedRequests = result.data
    }else{
      this.allDriverPartner_RejectedRequests = [];
    }
  })
}
//  Rejected Requests End
searchBy="";
searchTeaxt="";
search(){
  this.spinner.show();
  let data = {
    "fieldName" :  this.searchBy,
    "searchText" : this.searchText
  }
  console.log(data);
  this.driverPartnerService.searchDrivers(data).subscribe((result:any)=>{
    if(result.statusCode == 200){
      this.spinner.hide()
      console.log(result) 
      this.allDriverPartner_PendingRequests=result.data.filter((driver: any) => driver.verificationStatus === 0 || driver.verificationStatus === "0")
      this.allDriverPartner_InProcessRequests=result.data.filter((driver: any) => driver.verificationStatus === 1 || driver.verificationStatus === "1")
      this.allDriverPartner_CompletedRequests=result.data.filter((driver: any) => driver.verificationStatus === 2 || driver.verificationStatus === "2")
      this.allDriverPartner_RejectedRequests=result.data.filter((driver: any) => driver.verificationStatus === 3 || driver.verificationStatus === "3")
    }else{
      this.spinner.hide()
      this.allDriverPartner_PendingRequests=[];
      this.allDriverPartner_InProcessRequests=[];
      this.allDriverPartner_CompletedRequests=[];
      this.allDriverPartner_RejectedRequests=[];
    }
  })
}

getDriverDocuments(){
  this.spinner.show()
  let data = {
    "driverId" : this.driverId
  }
  // console.log(data)
  this.driverPartnerService.getDriverUploadedDocuments(data).subscribe((result:any)=>{
    if(result.statusCode == 200){
      console.log(result);
      this.driverDocumentsData =[];
      this.driverDocumentsData = result.data;
      this.spinner.hide()
    }else{
      this.spinner.hide()
      this.toastr.error(result.message)
    }
  })
}

  updateRequest(){
    this.spinner.show()
    let sendKey = {
      "id" : this.changeStatusId,
      "status" : Number(this.status),
      "pendingReason":String(this.pendingReason),
      "rejectReason":String(this.rejectReason),
      "isBannerPasted":this.isBannerPasted
    }
    console.log("reqStatus",sendKey)
    this.driverPartnerService.changeDriverRequestStatus(sendKey).subscribe((result:any)=>{
      if(result.statusCode == 200){
            this.spinner.hide();
            this.toastr.success(result.message);
            this.getDriverPartnerRequests_Pending();
            this.getDriverPartnerRequests_InProcess()
            this.getDriverPartnerRequests_Completed()
            this.getDriverPartnerRequests_Rejected();
            this.modalService.dismissAll();
      }else{
        this.spinner.hide();
        this.toastr.error(result.message);
        this.modalService.dismissAll();
      }
    })
  }
  updateDriver(){
    let data={
      "id":this._id,
      "firstName":this.firstName,
      "lastName":this.lastName,
      "city":this.city,
      "phoneNumber":this.phoneNumber,
      "emailId":this.emailId,
      "vehicleType":this.vehicleType,
      "vehicleNumber":this.vehicleNumber,
      "homeStopLocation":this.homeStopLocation,
      "homeStopLng":this.homeStopLng,
      "homeStopLat":this.homeStopLat,  
      "isDeleted": this.isDeleted,
      "nameAsPerBank":this.nameAsPerBank,
      "bankAccountNumber":this.bankAccountNumber,
      "bankName":this.bankName,
      "ifscCode":this.ifscCode,
      "upiMobileNumber":this.upiMobileNumber,
      "paymentApp":this.paymentApp,
      "upiID":this.upiID,
      "isBannerPasted":this.isBannerPasted
    }
    // console.log(data)
    this.spinner.show();
    this.driverPartnerService.updateDriver(data).subscribe((result:any)=>{
        if(result.statusCode == 200){
          // console.log(result)
          this.spinner.hide()
          this.toastr.success(result.message)
          this.getDriverPartnerRequests_Pending();
          this.modalService.dismissAll()
        }else{
          this.spinner.hide()
          this.toastr.error(result.message)
        }
    })
  }

  viewDetails(content1 : any ,data : any){
    this.status = ''
    this.viewAllData = data;
    console.log(this.viewAllData.status)
    this.driverId = data._id;
    this.changeStatusId = data._id;
    this.openViewDeatilsModal(content1);
  }
  _id:any;
  getData:any
  firstName:any;
  lastName:any;
  city:any;
  phoneNumber:any;
  vehicleNumber:any;
  emailId:any;
  vehicleType:any;
  nameAsPerBank:any;
  bankAccountNumber:any;
  bankName:any;
  ifscCode:any;
  upiMobileNumber:any;
  paymentApp:any;
  homeStopLocation:any;
  homeStopLat:any;
  homeStopLng:any;
  isDeleted:any | number;
  upiID:any
  editDetails(content3:any ,data:any){
    this.getData = data;
    // console.log(this.getData)
    this._id = data._id;
    this.firstName = data.firstName;
    this.lastName = data.lastName; 
    this.city = data.city; 
    this.phoneNumber = data.phoneNumber; 
    this.vehicleNumber=data.vehicleNumber;
    this.emailId = data.emailId; 
    this.vehicleType=data.vehicleType,
    this.nameAsPerBank=data.nameAsPerBank,
    this.bankAccountNumber=data.bankAccountNumber,
    this.bankName=data.bankName,
    this.ifscCode=data.ifscCode,
    this.upiMobileNumber=data.upiMobileNumber,
    this.paymentApp=data.paymentApp,
    this.homeStopLocation=data.homeStopLocation,
    this.homeStopLat=data.homeStopLat,
    this.homeStopLng=data.homeStopLng,
    this.isDeleted=data.isDeleted,
    this.upiID=data.upiID,
    this.isBannerPasted=data.isBannerPasted
    this.openEditDeatilsModal(content3);
  }
  getHomeStopData(address:any){
    this.homeStopLocation=address.formatted_address
    this.homeStopLat = address.geometry.location.lat()
    this.homeStopLng = address.geometry.location.lng()
    console.log("lat", this.homeStopLat, "lng", this.homeStopLng, "home stop", this.homeStopLocation)
  }

  changeStatus(content2:any , data:any){
    this.status = ''
    // this.isBannerPasted= data.isBannerPasted
    this.changeStatusId = data._id;
    this.driverId = data._id;
    this.openchangeStatusModal(content2);
  }

  applyFilter(filterValue:any){
    console.log(filterValue);
    let filterValueLower = filterValue.toLowerCase();
         if(filterValue === '' ) {
             this.allDriverPartner_PendingRequests=this.allDriverPartnerRequestsList_forFilter;
         } 
         else {
           this.allDriverPartner_PendingRequests = this.allDriverPartnerRequestsList_forFilter.filter((employee:any) => employee.city.toLowerCase().includes(filterValueLower) )
          }
  }

  allDrivers:any;
  getAllDrivers(perPage:any, veriStatus:Number){
    this.spinner.show();       
    let data = { 
      "perPage" :  perPage,
      "page"    : 0,
      "isDeleted": 0,
      "verificationStatus" : veriStatus,
    }
    // console.log(data)
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      console.log('all data',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allDrivers = result.data
        console.log(this.allDrivers)
        this.exportAllToExcel(this.allDrivers)
      }else{
        this.allDrivers = [];
      }
    })
  }

  allVehiclesList:any
  getVehicles(){
    this.spinner.show();
      let data ={"currentStatus":1,"isDeleted":0}
      this.driverPartnerService.getAllvehicles(data).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          // console.log(result)
          this.allVehiclesList = result.data.filter((vehicle:any) => vehicle.currentStatus !== 0)
          // console.log(this.allVehiclesList)
        }else{
          this.spinner.hide();
          this.allVehiclesList =[]
        }
      })
}

  exportToExcel() {
    // Find the active tab content
    const activeTab = document.querySelector('.tab-pane.active');
    
    if (!activeTab) {
      console.error('No active tab found!');
      return;
    }
  
    // Find the table within the active tab
    const element = activeTab.querySelector('#excel-table');
    
    if (!element) {
      console.error('Table not found in the active tab!');
      return;
    }
  
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // Generate workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Save to file
    XLSX.writeFile(wb, "Drivers_Report.xlsx");
  }

   exportAllToExcel(array:any) {
    // Filter to include only the 'name' field
    const data = array.map((item: any) => ({ ID: item._id, Name:item.firstName + " " +item.lastName, Mobile:item.phoneNumber, Email:item.emailId, City:item.city, HomeStop:item.homeStopLocation, VehicleType:item.vehicleType }));
        
    // Convert the filtered array to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Generate workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Save to file
    XLSX.writeFile(wb, "Driver_Partner_Report.xlsx");
  }

  
  openViewDeatilsModal(content:any) {
    this.modalService.open(content , { size : 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  openEditDeatilsModal(content3:any) {
    this.modalService.open(content3 , { size : 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openchangeStatusModal(content2:any) {
    this.modalService.open(content2).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

 // Select image code start
 isValidImage: any;
 isImageUploaded:any;
 imageUrl = "";

 isValidImage_DrLicense:any;
 isImageUploaded_DrLicense:any;
 imageUrl_DrLicense="";

 isValidImage_AdharCard_F:any;
 isImageUploaded_AdharCard_F:any;
 imageUrl_AdharCard_F="";

 isValidImage_AdharCard_B:any;
 isImageUploaded_AdharCard_B:any;
 imageUrl_AdharCard_B="";

 isValidImage_RC:any;
 isImageUploaded_RC :any;
 imageUrl_RC="";

 isValidImage_INSURANCE:any;
 isImageUploaded_INSURANCE :any;
 imageUrl_INSURANCE="";

 isValidImage_ROADTAX:any;
 isImageUploaded_ROADTAX :any;
 imageUrl_ROADTAX="";

 isValidImage_DriverSelfie:any;
 isImageUploaded_DriverSelfie :any;
 imageUrl_DriverSelfie="";

 isValidImage_Vehicle_F:any;
 isImageUploaded_Vehicle_F :any;
 imageUrl_Vehicle_F="";

 isValidImage_Vehicle_B:any;
 isImageUploaded_Vehicle_B :any;
 imageUrl_Vehicle_B="";

 isValidImage_Vehicle_R:any;
 isImageUploaded_Vehicle_R :any;
 imageUrl_Vehicle_R="";

 isValidImage_Vehicle_L:any;
 isImageUploaded_Vehicle_L :any;
 imageUrl_Vehicle_L="";

 

 getVehicleImage(event : any, type : any) {
   if(type == "VEHICLE_IMAGE"){
     if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
       this.isValidImage = false;
       this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
         console.log(result)
         if(result.statusCode == 200){
             this.isImageUploaded = true;
             this.imageUrl = result.photoUrl;
             let data={
              "documentType": "DriverSelfie",
              "driverId":this.driverId,
              "location":this.imageUrl
          }
          console.log(data)
          this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
            if(result.statusCode == 200){
              this.spinner.hide()
              this.toastr.success(result.message);
            }else{
              this.spinner.hide();
              this.toastr.error(result.message)
            }
          })
         }else{
           this.isImageUploaded = false;
           this.imageUrl = "";
         }
         this.isValidImage = false;
       })

   } else {
     this.isValidImage = true;
     this.isImageUploaded = false;
   }
 } else if (type == "RC_IMAGE"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_RC = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_RC = true;
           this.imageUrl_RC = result.photoUrl;
           let data={
            "documentType": "RcDocument",
            "driverId":this.driverId,
            "location":this.imageUrl_RC
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_RC = false;
         this.imageUrl_RC = "";
       }
       this.isValidImage_RC = false;
     })

 } else {
   this.isValidImage_RC = true;
   this.isImageUploaded_RC = false;
 }
 } else if (type == "INSURANCE_IMAGE"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_INSURANCE = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_INSURANCE = true;
           this.imageUrl_INSURANCE = result.photoUrl;
           let data={
            "documentType": "InsuranceDocument",
            "driverId":this.driverId,
            "location":this.imageUrl_INSURANCE
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_INSURANCE = false;
         this.imageUrl_INSURANCE = "";
       }
       this.isValidImage_INSURANCE = false;
     })

 } else {
   this.isValidImage_INSURANCE = true;
   this.isImageUploaded_INSURANCE = false;
 }
 } else if (type == "DRIVING_LICENSE"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_DrLicense = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_DrLicense = true;
           this.imageUrl_DrLicense = result.photoUrl;
           let data={
            "documentType": "DrivingLicense",
            "driverId":this.driverId,
            "location":this.imageUrl_DrLicense
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_DrLicense = false;
         this.imageUrl_DrLicense = "";
       }
       this.isValidImage_DrLicense= false;
     })

 } else {
   this.isValidImage_DrLicense = true;
   this.isImageUploaded_DrLicense = false;
 }
 }else if (type == "ADHAR_CARD_F"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_AdharCard_F = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_AdharCard_F = true;
           this.imageUrl_AdharCard_F = result.photoUrl;
           let data={
            "documentType": "AdharFront",
            "driverId":this.driverId,
            "location":this.imageUrl_AdharCard_F
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_AdharCard_F = false;
         this.imageUrl_AdharCard_F = "";
       }
       this.isValidImage_AdharCard_F= false;
     })

 } else {
   this.isValidImage_AdharCard_F = true;
   this.isImageUploaded_AdharCard_F = false;
 }
 }else if (type == "ADHAR_CARD_B"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_AdharCard_B = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_AdharCard_B = true;
           this.imageUrl_AdharCard_B = result.photoUrl;
           let data={
            "documentType": "AdhaBack",
            "driverId":this.driverId,
            "location":this.imageUrl_AdharCard_B
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_AdharCard_B = false;
         this.imageUrl_AdharCard_B = "";
       }
       this.isValidImage_AdharCard_B= false;
     })

 } else {
   this.isValidImage_AdharCard_B = true;
   this.isImageUploaded_AdharCard_B = false;
 }
 }else if (type == "VEHICLE_F"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_Vehicle_F = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_Vehicle_F = true;
           this.imageUrl_Vehicle_F = result.photoUrl;
           let data={
            "documentType": "VehicleFront",
            "driverId":this.driverId,
            "location":this.imageUrl_Vehicle_F
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_Vehicle_F = false;
         this.imageUrl_Vehicle_F = "";
       }
       this.isValidImage_Vehicle_F= false;
     })

 } else {
   this.isValidImage_Vehicle_F = true;
   this.isImageUploaded_Vehicle_F = false;
 }
 }else if (type == "VEHICLE_B"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_Vehicle_B = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_Vehicle_B = true;
           this.imageUrl_Vehicle_B = result.photoUrl;
           let data={
            "documentType": "VehicleBack",
            "driverId":this.driverId,
            "location":this.imageUrl_Vehicle_B
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_Vehicle_B = false;
         this.imageUrl_Vehicle_B = "";
       }
       this.isValidImage_Vehicle_B= false;
     })

 } else {
   this.isValidImage_Vehicle_B = true;
   this.isImageUploaded_Vehicle_B = false;
 }
 }else if (type == "VEHICLE_R"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_Vehicle_R = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_Vehicle_R = true;
           this.imageUrl_Vehicle_R = result.photoUrl;
           let data={
            "documentType": "VehicleRight",
            "driverId":this.driverId,
            "location":this.imageUrl_Vehicle_R
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_Vehicle_R = false;
         this.imageUrl_Vehicle_R = "";
       }
       this.isValidImage_Vehicle_R= false;
     })

 } else {
   this.isValidImage_Vehicle_R = true;
   this.isImageUploaded_Vehicle_R = false;
 }
 }else if (type == "VEHICLE_L"){
   if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
     this.isValidImage_Vehicle_L = false;
     this.driverPartnerService.addImage(event.target.files[0]).subscribe((result:any)=>{
       console.log(result)
       if(result.statusCode == 200){
           this.isImageUploaded_Vehicle_L = true;
           this.imageUrl_Vehicle_L = result.photoUrl;
           let data={
            "documentType": "VehicleLeft",
            "driverId":this.driverId,
            "location":this.imageUrl_Vehicle_L
        }
        console.log(data)
        this.driverPartnerService.uploadImage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
          }else{
            this.spinner.hide();
            this.toastr.error(result.message)
          }
        })
       }else{
         this.isImageUploaded_Vehicle_L = false;
         this.imageUrl_Vehicle_L = "";
       }
       this.isValidImage_Vehicle_L= false;
     })

 } else {
   this.isValidImage_Vehicle_L = true;
   this.isImageUploaded_Vehicle_L = false;
 }
 }
 
}

}


